// extracted by mini-css-extract-plugin
module.exports = {"logout-container":"_logout_logout-container__3BzUn","description":"_logout_description__19o8_"};